import {Button} from "@pg-design/button-module";
import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOMEMATCH_TINDER_ACTION_BAR_CONTENT} from "../constants/homematch_tinder_content";
import {HomematchThumbDirection} from "../types/HomematchThumbDirection";

import * as styles from "./HomematchTinderActionBar.module.css";

interface IProps {
    askDataTestId?: string;
    disabled?: boolean;
    onThumbClick: (direction: HomematchThumbDirection) => void;
    rejectDataTestId?: string;
    vendorLogoUrl?: string | null;
    vendorName?: string | null;
}

export const HomematchTinderActionBar = (props: IProps) => {
    const {askDataTestId, disabled = false, onThumbClick, rejectDataTestId, vendorLogoUrl, vendorName} = props;
    const {isMobile} = useUserDevice();
    const hasVendorInfo = Boolean(vendorLogoUrl || vendorName);
    const buttonSize = isMobile ? "small" : "medium";

    return (
        <div className={styles.bar}>
            {hasVendorInfo && (
                <div className={styles.vendorRow}>
                    {vendorLogoUrl && (
                        <Image
                            alt={HOMEMATCH_TINDER_ACTION_BAR_CONTENT.VENDOR_LOGO_ALT}
                            className={styles.vendorLogoWrapper}
                            height="48"
                            src={vendorLogoUrl}
                            width="64"
                        />
                    )}

                    {vendorName && <Text variant="body_copy_2">{HOMEMATCH_TINDER_ACTION_BAR_CONTENT.getLeadInfoText(vendorName)}</Text>}
                </div>
            )}

            <div className={styles.buttonsRow}>
                <Button
                    className={styles.button}
                    dataTestId={rejectDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbDownIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Down)}
                    size={buttonSize}
                    variant="outlined_secondary"
                >
                    {HOMEMATCH_TINDER_ACTION_BAR_CONTENT.REJECT_BUTTON}
                </Button>

                <Button
                    className={styles.button}
                    dataTestId={askDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbUpIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Up)}
                    size={buttonSize}
                    variant="filled_primary"
                >
                    {HOMEMATCH_TINDER_ACTION_BAR_CONTENT.ASK_BUTTON}
                </Button>
            </div>
        </div>
    );
};
import {Button} from "@pg-design/button-module";
import {ThumbDownIcon, ThumbUpIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {HOMEMATCH_TINDER_ACTION_BAR_CONTENT} from "../constants/homematch_tinder_content";
import {HomematchThumbDirection} from "../types/HomematchThumbDirection";

import * as styles from "./HomematchTinderActionBar.module.css";

interface IProps {
    askDataTestId?: string;
    disabled?: boolean;
    onThumbClick: (direction: HomematchThumbDirection) => void;
    rejectDataTestId?: string;
    vendorLogoUrl?: string | null;
    vendorName?: string | null;
}

export const HomematchTinderActionBar = (props: IProps) => {
    const {askDataTestId, disabled = false, onThumbClick, rejectDataTestId, vendorLogoUrl, vendorName} = props;
    const {isMobile} = useUserDevice();
    const hasVendorInfo = Boolean(vendorLogoUrl || vendorName);
    const buttonSize = isMobile ? "small" : "medium";

    return (
        <div className={styles.bar}>
            {hasVendorInfo && (
                <div className={styles.vendorRow}>
                    {vendorLogoUrl && (
                        <Image
                            alt={HOMEMATCH_TINDER_ACTION_BAR_CONTENT.VENDOR_LOGO_ALT}
                            className={styles.vendorLogoWrapper}
                            height="48"
                            src={vendorLogoUrl}
                            width="64"
                        />
                    )}

                    {vendorName && <Text variant="body_copy_2">{HOMEMATCH_TINDER_ACTION_BAR_CONTENT.getLeadInfoText(vendorName)}</Text>}
                </div>
            )}

            <div className={styles.buttonsRow}>
                <Button
                    className={styles.button}
                    dataTestId={rejectDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbDownIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Down)}
                    size={buttonSize}
                    variant="outlined_secondary"
                >
                    {HOMEMATCH_TINDER_ACTION_BAR_CONTENT.REJECT_BUTTON}
                </Button>

                <Button
                    className={styles.button}
                    dataTestId={askDataTestId}
                    disabled={disabled}
                    iconLeft={ThumbUpIcon}
                    iconLeftProps={{className: styles.icon}}
                    onClick={() => onThumbClick(HomematchThumbDirection.Up)}
                    size={buttonSize}
                    variant="filled_primary"
                >
                    {HOMEMATCH_TINDER_ACTION_BAR_CONTENT.ASK_BUTTON}
                </Button>
            </div>
        </div>
    );
};
